var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNextPlan = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_26293_4992)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.57164 6.57191C1.36734 11.7762 1.36734 20.2238 6.57164 25.4281C11.776 30.6324 20.2235 30.6324 25.4278 25.4281C30.6321 20.2238 30.6321 11.7762 25.4278 6.57191C20.2235 1.36761 11.776 1.3676 6.57164 6.57191ZM23.5139 12.2005L18.7999 16.9145L18.7999 12.653C16.9425 12.5116 15.0381 13.1339 13.6144 14.5575C11.38 16.792 11.0783 20.2238 12.6905 22.7977L11.4837 23.4011C9.61692 20.3275 10.0129 16.2734 12.6716 13.6147C14.3498 11.9365 16.5937 11.1822 18.7999 11.3142L18.7999 7.48644L23.5139 12.2005Z",
  fill: "#079D56"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_26293_4992"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNextPlan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/next-plan.eee4e0fc5a28e27aee4ade826696b638.svg";